module.exports = __webpack_public_path__ + "img/logo.1905738b.svg";